import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useWindowScroll } from "react-use";
import styles from "./Navbar.module.css";

const navItems = [
  { label: "Accueil", id: "hero" },
  { label: "À propos", id: "about" },
  { label: "Fonctionnalités", id: "features" },
  { label: "Avantages", id: "benefits" },
];

const NavBar = ({ onShowPopup }) => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const { y: currentScrollY } = useWindowScroll();
  const [isNavVisible, setIsNavVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const isFloating = currentScrollY > 10;

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    element?.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  const handleLogoClick = () => {
    scrollToSection("hero");
  };

  const navRef = useRef(null);

useEffect(() => {
    if (currentScrollY <= 0) {
      // Tout en haut : état initial
      setIsNavVisible(true);
      navRef.current?.classList.remove(styles.floatingNav);
      navRef.current?.classList.add(styles.HiddenNav);
    } else if (currentScrollY > lastScrollY) {
      // On descend : on cache la barre
      setIsNavVisible(false);
      navRef.current?.classList.add(styles.floatingNav);
    } else if (currentScrollY < lastScrollY) {
      // On remonte : on montre la barre (mode flottant)
      setIsNavVisible(true);
      navRef.current?.classList.add(styles.floatingNav);
    }
    setLastScrollY(currentScrollY);
  }, [currentScrollY, lastScrollY]);

  const handleLogin = () => {
    if (onShowPopup) {
      onShowPopup();
    } else {
      navigate("/login");
    }
  };

  return (
<nav 
      ref={navRef} 
      className={`
        ${styles.navbar} 
        ${!isNavVisible ? styles.navHidden : ""} 
        ${isFloating ? styles.floatingNav : ""}
      `}
    >
      <div className={styles.navContainer}>
        {/* Logo */}
        <div className={styles.navLogo} onClick={handleLogoClick} style={{ cursor: "pointer" }}>
          <img src="/images/logo.png" alt="SEF Cheptel"  className={styles.logoImg} />
        </div>

        {/* Desktop Menu */}
        <div className={`${styles.navContent} ${menuOpen ? styles.active : ""}`}>
          <ul className={styles.navMenu}>
            {navItems.map((item, index) => (
              <li key={index}>
                <a
                  href={`#${item.id}`}
                  onClick={() => scrollToSection(item.id)}
                  className={styles.navLink}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
          <button className={styles.loginBtn} onClick={handleLogin}>
            Se connecter
          </button>
        </div>

        {/* Menu Toggle */}
        <div
          className={`${styles.menuToggle} ${menuOpen ? styles.active : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
  );
};



export default NavBar;
